import { IncomingMessage } from 'http';
import { fechFromBPartsApi } from '../utils';

export const setShippingLocation = ({
  locale,
  shipping_location,
  csrftoken,
  req,
}: {
  locale: string;
  shipping_location: string;
  csrftoken: string;
  req?: IncomingMessage;
}): Promise<{ setCookie: string[] }> =>
  fechFromBPartsApi<Response>(`/${locale}/shop/shipping_locations/change`, {
    method: 'PUT',
    headers: new Headers({
      ...(!!req ? (req?.headers as HeadersInit) : {}),
      'Content-Type': 'application/json',
      'X-CSRFToken': csrftoken || '',
    } as HeadersInit),
    credentials: 'include',
    body: JSON.stringify({ value: shipping_location }),
  }).then(async (value) => {
    if (value.status >= 400 && value.status < 600) {
      const json = await value.json();
      throw { ...json, status: value.status };
    }

    // Expose the backend's Set-Cookie headers so SSR callers can propagate the
    // backend session state to the client (single source of truth) instead of
    // hand-setting cookies. On the browser, Set-Cookie is unreadable, so this
    // is simply an empty array there.
    const headers = value.headers as Headers & {
      getSetCookie?: () => string[];
    };
    const setCookie =
      typeof headers.getSetCookie === 'function'
        ? headers.getSetCookie()
        : headers.get('set-cookie')
          ? [headers.get('set-cookie') as string]
          : [];

    return { setCookie };
  });
